import {setStore, getStore} from '@/util/store'
import {login, getUserInfo, logout, register, smsSend} from '@/api/login'

const user = {
  state: {
    userInfo: getStore({
      name: 'userInfo'
    }) || {},
    loginFlag: getStore({
      name: 'loginFlag'
    }) || false
  },
  actions: {
    // 根据用户名登录
    LoginByUsername(mutation, payload) {
      return new Promise((resolve, reject) => {
        login(payload.username, payload.password, payload.validateCode, payload.rememberMe).then(response => {
          if (response.data.code == 0) {
            // 登录成功，用户信息存入store
            const userInfo = response.data.data
            mutation.commit("SET_USER_INFO", userInfo)
            mutation.commit("SET_LOGIN_FLAG", true)
            resolve()
          } else {
            // 登录失败，返回错误信息
            reject({msg: response.data.msg})
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 注册
    register(mutation, data) {
      return new Promise((resolve, reject) => {
        register(data).then(response => {
          if (response.data.code == 0) {
            resolve()
          } else {
            // 注册失败，返回错误信息
            reject({msg: response.data.msg})
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 注册短信验证码
    smsSend(mutation, data) {
      return new Promise((resolve, reject) => {
        smsSend(data.mobile, data.code).then(response => {
          //console.log(response);
          if (response.data.code == 0) {
            resolve()
          } else {
            // 失败，返回错误信息
            reject({msg: response.data.msg})
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserInfo() {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          // const data = response.data.data
          // commit('SET_USER_INFO', data.sysUser)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LogOut(mutation) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          mutation.commit('SET_USER_INFO', {})
          mutation.commit('SET_LOGIN_FLAG', false)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 注销
    FedLogOut(mutation) {
      return new Promise(resolve => {
        // 清除用户信息
        mutation.commit('SET_USER_INFO', {})
        mutation.commit('SET_LOGIN_FLAG', false)
        resolve()
      })
    },
  },
  mutations: {
    SET_AVATAR: (state, avatar) => {
      state.userInfo.avatar = avatar;
      setStore({
        name: 'userInfo',
        content: state.userInfo,
        type: 'session'
      })
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      setStore({
        name: 'userInfo',
        content: state.userInfo,
        type: 'session'
      })
    },
    SET_LOGIN_FLAG: (state, loginFlag) => {
      state.loginFlag = loginFlag
      setStore({
        name: 'loginFlag',
        content: state.loginFlag,
        type: 'session'
      })
    }
  }
}
export default user
